/**
 * 站点名共享 hook（收敛此前 9 份逐字重复的本地定义）。
 *
 * 页面级 document.title 的设置仍由各页自行处理（部分页面带专属后缀）。
 */

import { useEffect, useState } from 'react';
import { api } from '../services/api';

export function useSiteName(defaultName = 'AI 图片生成') {
  const [siteName, setSiteName] = useState(defaultName);

  useEffect(() => {
    api
      .getSiteName()
      .then((res) => setSiteName(res.siteName))
      .catch(() => {});
  }, []);

  return siteName;
}
